export const PRODUCTS = 'PRODUCTS';
export const CONTACTS = 'CONTACTS_IN_CRM';
export const MARKETING_CONTACTS = 'MARKETING_CONTACTS';
export const PURCHASE_MOTIONS = 'PURCHASE_MOTIONS';
export const COMPANY_DETAILS = 'COMPANY_DETAILS';